import { render, staticRenderFns } from "./NewSection.vue?vue&type=template&id=20a688eb&"
import script from "./NewSection.vue?vue&type=script&lang=js&"
export * from "./NewSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports